import angular from 'angular';
import moment from 'moment';
import { compactRelation } from '../../common/Filters/relationNameFilter';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { RegistrationGroup } from '../../registrations/model/registrationGroup';

angular.module('cxRelations').directive('relTodos', function() {
  return {
    restrict: 'E',
    template: require('./relTodos.html'),
    scope: {
      relation: '=',
      fieldId: '@id',
    },
    controllerAs: 'vm',
    bindToController: true,
    require: ['^cxRelationFile', 'relTodos'],
    link: function(scope, el, attrs, controllers) {
      if (!controllers || controllers.length !== 2) return;
      var cxRelFile = controllers[0];
      var controller = controllers[1];
      controller.setRelationFile(cxRelFile);
    },
    controller: [
      '$http',
      '$q',
      'flySvc',
      'appUrls',
      'ModalService',
      '$filter',
      'dialogsSvc',
      'dataCache',
      'registrationService',
      'regDialogsSvc',
      '$timeout',
      function(
        $http,
        $q,
        flySvc,
        appUrls,
        ModalService,
        $filter,
        dialogsSvc,
        dataCache,
        registrationService,
        regDialogsSvc,
        $timeout,
      ) {
        var vm = this;
        const now = moment.utc();
        const inOneWeek = moment.utc().add(1, 'weeks');
        const users = dataCache.getArray('user');

        vm.items = null;
        vm.loading = false;

        var relationFile = null;
        vm.setRelationFile = function(relFile) {
          relationFile = relFile;
        };

        const isPastDeadline = todo => {
          const deadlineUtc = moment.utc(todo.deadline);
          return now.isAfter(deadlineUtc);
        };

        const isNearingDeadline = todo => {
          const deadlineUtc = moment.utc(todo.deadline);
          return deadlineUtc.isAfter(now) && deadlineUtc.isBefore(inOneWeek);
        };

        const getUserName = function(userId) {
          if (!users || !userId) return;
          const employee = users.find(e => e.userID === userId);
          if (!employee) return;
          return employee.firstName + ' ' + employee.lastName;
        };

        const mapStatus = (originalTodo, statusResult) => {
          if (statusResult.isBlocked) {
            originalTodo.status = 3;
          } else if (statusResult.inapplicable) {
            originalTodo.status = 4;
          } else if (statusResult.rejected) {
            originalTodo.status = 6;
          } else if (statusResult.status <= 2) {
            originalTodo.status = statusResult.status;
          }
          if (statusResult.deadline) {
            originalTodo.deadline = statusResult.deadline;
          }
          if (statusResult.userId) {
            originalTodo.userId = statusResult.userId;
            originalTodo.user = getUserName(statusResult.userId);
          }
          return originalTodo;
        };

        var mapTodo = function(item) {
          item.isNearingDeadline = isNearingDeadline(item);
          item.isPastDeadline = isPastDeadline(item);
          item.user = getUserName(item.userId);
          return item;
        };

        var loadTodos = function(reload) {
          if (!reload && vm.items != null) return;
          vm.loading = true;
          vm.items = [];

          const requestParameters = {
            relationId: vm.relation.id,
            desc: false,
            page: 0,
            mainStatus: [0, 1, 3],
            ownCompanies: [],
            period: 'all',
            relationTypes: [],
            taskLevels: [2], // Todo's
            sortKey: 'deadline',
            take: 50,
          };

          $http.post(appUrls.tasks + '/api/tasklist', requestParameters).then(
            function(response) {
              vm.items = response.data.tasks.map(mapTodo);
              vm.loading = false;
            },
            error => {
              vm.loading = false;
              flySvc.error(error);
            },
          );
        };

        vm.add = function() {
          vm.showCreateTodoModal = true;
        };

        vm.onStatusChanged = todos => {
          if (angular.isArray(todos)) {
            todos.forEach(todo => {
              vm.items = vm.items.map(x => {
                if (x.id === todo.id) {
                  return {
                    ...x,
                    ...mapStatus(x, todo),
                  };
                }
                return x;
              });
            });
          } else if (todos?.id) {
            vm.items = vm.items.map(x => {
              if (x.id === todos.id) {
                return {
                  ...x,
                  ...mapStatus(x, todos),
                };
              }
              return x;
            });
          }
        };

        vm.remove = function(item) {
          if (item.removing) return;
          return dialogsSvc
            .showYesNo('msgConfirmDeleteTitle', 'msgConfirmDeleteTodo')
            .then(function() {
              item.removing = true;
              $http.delete(appUrls.tasks + '/api/plannedtasks/' + item.id).then(
                function() {
                  var idx = vm.items.indexOf(item);
                  if (idx >= 0) vm.items.splice(idx, 1);
                  flySvc.success('msgItemRemoved');
                },
                function(error) {
                  flySvc.error(error);
                  item.removing = false;
                },
              );
              return true;
            });
        };

        vm.openTaskModal = todo => {
          vm.showTaskModal = true;
          vm.activeTask = todo;
        };

        vm.onTaskModalClosed = () => {
          $timeout(function() {
            vm.showTaskModal = false;
            vm.activeTask = null;
          }, 0);
        };

        vm.onCreateTodoModalClosed = () => {
          $timeout(function() {
            vm.showCreateTodoModal = false;
          }, 0);
        };

        vm.onCreateTodoModalSaved = todo => {
          $timeout(function() {
            vm.showCreateTodoModal = false;
            if (todo.relationId === vm.relation.id) vm.items.push(mapTodo(todo));
            relationFile.getRelationKPIData();
          }, 0);
        };

        vm.onTaskModalSaved = updatedTasks => {
          $timeout(function() {
            vm.showTaskModal = false;
            vm.activeTask = null;

            if (angular.isArray(updatedTasks)) {
              updatedTasks.forEach(todo => {
                vm.items = vm.items.map(x => {
                  if (x.id === todo.id) {
                    return {
                      ...x,
                      ...mapTodo(todo),
                    };
                  }
                  return x;
                });
              });
            }
          }, 0);
        };

        vm.createRegistration = function(todo) {
          vm.disableCreateRegistration = true;
          var reg = new RegistrationGroup();
          reg.date = moment
            .utc()
            .startOf('day')
            .toDate();

          const relation = {
            ...compactRelation(vm.relation),
            invoiceStreamId: todo.invoiceStreamId,
            invoiceStreams: vm.relation.invoiceStreams,
          };
          reg.relation = relation;
          reg.invoiceStreamId = todo.invoiceStreamId;
          reg.setRelation();
          reg.task = todo.id;

          reg.setTaskFields({
            plannedTaskId: todo.id,
            plannedTaskName: todo.name,
          });
          const userId = dataCache.getArray('employee').userID;

          registrationService
            .getNextRegistrationTime(
              moment
                .utc()
                .startOf('day')
                .toDate(),
            )
            .then(function(data) {
              if (data) reg.work.initTime(data.Hour, data.Minute, 0);

              reg.setUser(userId);

              var vat = dataCache.getDefaultCompany().resourceVATRate || 0.21;
              reg.work.setVatRate(vat, 0);
              reg.cost.setVatRate(vat, 0);
              reg.travel.setVatRate(vat, 0);
              regDialogsSvc.editRegistrationGroup(reg).then(function(result) {
                if (result) {
                  flySvc.success('Registration created');
                }
              });
            })
            .finally(() => {
              vm.disableCreateRegistration = false;
            });
        };

        vm.toggleCollapsed = function(collapsed) {
          if (!collapsed) loadTodos();
        };
      },
    ],
  };
});
